import { z } from 'zod';
import { requiredString } from '../helpers';
export const SMTP_Forward_Email_1_ConfigValidator = z.object({
    smtpConnection: requiredString('SMTP Connection is required'),
    emailFrom: requiredString('From Email is required'),
    emailTo: requiredString('To Email is required'),
    emailCc: z.string().optional(),
    includeAttachments: z.boolean().default(false)
});
//# sourceMappingURL=smtp-forward-email-1.js.map